import React from 'react';
import classnames from 'classnames';
import { SvgProps } from './icon.types';

function ChevronDownIcon({ fillColor = '#2D3049', className, stroke, ...props }: SvgProps) {
  const rootClassName = classnames('pointer-events-none', className);
  return (
    <svg className={rootClassName} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 5L2 6l7 7 7-7-1-1-6 6z" fill={fillColor} fillRule="evenodd" stroke={stroke} />
    </svg>
  );
}

export { ChevronDownIcon };
